import React, { Component } from 'react';
import CheckoutRightBlock from './checkoutRightBlock';
import CheckoutLeftBlock from './checkoutLeftBlock';
import { Link } from 'react-router-dom';

class Checkout extends Component {
  state = {};

  //   componentDidMount() {
  //     this.setState({ cartItems: this.props.cartItems });
  //   }

  //   handleCartErrors = (items) => {
  //     const { cartItems } = this.props;
  // console.log(items)
  //     cartItems = items;

  //     this.setState({ cartItems });
  //   };

  render() {
    const { cartItems } = this.props;

    if (cartItems.length === 0)
      return (
        <div className='not-found'>
          <h1>Your cart is empty</h1>
          <Link to='/products/'>
            <button className='explore-categories'>Continue shopping</button>
          </Link>
        </div>
      );

    return (
      <div className='checkout-page row'>
        <CheckoutLeftBlock
          {...this.props}
          cartItems={cartItems}
          handleNotification={this.props.handleNotification}
          emptyCart={this.props.emptyCart}
          handleAddtoCart={this.props.handleAddtoCart}
        />

        <CheckoutRightBlock cartItems={cartItems} />
      </div>
    );
  }
}

export default Checkout;
